interface StaticImageProps {
    images: Record<string, string>;
    priority?: boolean;
}

const StaticImage = ({ images, priority }: StaticImageProps) => {
    if (!images || Object.keys(images).length === 0) return null;

    const breakpointSources = Object.keys(images)
        .filter((key) => key !== 'thumbnail' && !Number.isNaN(Number(key)))
        .sort((a, b) => Number(b) - Number(a));

    const fallbackSrc = images.thumbnail ?? images['465'] ?? images['924'] ?? images['1200'] ?? null;

    return (
        <picture>
            {breakpointSources.map((screenWidth) => {
                const imgUrl = images[screenWidth];

                return (
                    <source
                        data-test-id={`source-element-${screenWidth}`}
                        media={`(min-width: ${screenWidth}px)`}
                        srcSet={imgUrl}
                        key={`${screenWidth}-${imgUrl}`}
                    />
                );
            })}

            <img
                className="poster"
                src={fallbackSrc}
                alt=""
                loading={priority ? 'eager' : 'lazy'}
                fetchPriority={priority ? 'high' : 'low'}
                decoding="async"
            />
        </picture>
    );
};

export default StaticImage;
